<template>
  <group-mobile-grouped-view
    v-model="selectedCategories"
    :has-companies="selectedCompanies.length > 0"
    :loading="loading"
    :has-data="orders.length > 0"
    :days="days"
    :meal-total="mealTotal"
    :meal-categories="mealCategories"
    :shown-categories="shownCategories"
    :category-items="categoryItems"
  >
    <grouped-matrix-data
      ref="mealsTable"
      :loading="loading"
      :daily-data="processedDailyData"
      :meal-categories="mealCategories"
      :category-labels="categoryLabels"
      :selected-shift="selectedShifts"
      :selected-categories="selectedCategories"
      :date-array="dateArray"
    ></grouped-matrix-data>
  </group-mobile-grouped-view>
</template>

<script>
import ReportTabGroupMealsTabGroupedShiftMeals from "@/components/report/group-meals/ReportTabGroupMealsTabGroupedShiftMeals.vue";
import hasBarShifts from "../../../shared/hasBarShifts";
import hasShiftSubtitle from "../../../shared/hasShiftSubtitle";
import hasGroupedDays from "../../../shared/group/hasGroupedDays";
import GroupMobileGroupedView from "./GroupMobileGroupedView.vue";
import GroupedMatrixData from "./GroupedMatrixData.vue";

/**
 * Mobilni "Grupe jela": za svaki dan perioda koliko je obroka po grupi jela i smeni (kartica po danu). Smene,
 * firme i period su u zaglavlju, grupe jela se biraju u donjoj kartici. Nasleđuje učitavanje, štampu i Excel iz
 * starog taba; za štampu i Excel služi nevidljiva tabela GroupedMatrixData.
 */
export default {
  name: "GroupMobileGrouped",
  extends: ReportTabGroupMealsTabGroupedShiftMeals,
  mixins: [hasBarShifts, hasShiftSubtitle, hasGroupedDays],
  components: { GroupMobileGroupedView, GroupedMatrixData },
  computed: {
    groupedDaily() {
      return this.processedDailyData;
    },
  },
};
</script>
